// extracted by mini-css-extract-plugin
export var $animation_name = "Facts-module--$animation_name--47233";
export var Fact = "Facts-module--Fact--2b792";
export var Fact__image = "Facts-module--Fact__image--b3166";
export var Fact__inner = "Facts-module--Fact__inner--7fb3b";
export var Fact__inner___black = "Facts-module--Fact__inner___black--c61da";
export var Fact__inner___grey = "Facts-module--Fact__inner___grey--98d17";
export var Fact__inner___red = "Facts-module--Fact__inner___red--35b65";
export var Fact__inner___white = "Facts-module--Fact__inner___white--5ef0c";
export var Fact__inner___yellow = "Facts-module--Fact__inner___yellow--28d80";
export var Fact__question = "Facts-module--Fact__question--6eb2a";
export var Fact__reveal = "Facts-module--Fact__reveal--79723";
export var Fact__reveal__noImage = "Facts-module--Fact__reveal__noImage--af725";
export var Facts = "Facts-module--Facts--8ca58";
export var Facts__intro = "Facts-module--Facts__intro--52682";